import Selectr from 'mobius1-selectr';
import { debounce } from '../helpers';

export class Multiselect {
  constructor(options) {
    ({ element: this.element, options: this.options, onChange: this.onChange } = options);

    this.ready = false;
    this.lastAction = '';
    this.lastState = [];
    this._init();
  }

  _init() {
    this.selectr = new Selectr(this.element, {
      multiple: true,
      searchable: false,
      taggable: false,
      sortSelected: true,
      data: this.options.map(option => {
        return { value: option.value, text: option.text, disabled: option.disabled };
      }),
      customClass: 'tp-selectr',
    });

    this.selectr.on('selectr.init', () => {
      this.element.parentNode.addEventListener('mouseleave', () => {
        if (!this.selectr.opened && this._shouldTriggerChange(this.selectr.getValue())) {
          this._triggerChangeDebounced(this.selectr.getValue(), 1);
        }
      });
    });

    this.selectr.on('selectr.deselect', option => {
      if (this.ready && !this.selectr.getValue().length) {
        // if deselecting last option, put it back and don't trigger change
        this.selectr.setValue(option.value);
      } else {
        if (!this.selectr.opened) {
          const currentState = this.selectr.getValue();
          if (this._shouldTriggerChange(currentState)) {
            this._triggerChangeDebounced(currentState);
          }
        }
      }

      this.lastAction = 'deselect';
    });

    this.selectr.on('selectr.select', () => {
      if (!this.selectr.opened) {
        const currentState = this.selectr.getValue();
        if (this._shouldTriggerChange(currentState)) {
          this._triggerChangeDebounced(currentState);
        }
      }

      this.lastAction = 'select';
    });

    this.selectr.on('selectr.close', () => {
      // Library automatically triggers open and close event when deselecting by tags
      // It is needed to distinguish between fake close event and actual closing
      if (this.lastAction === 'deselect' || this.lastAction === 'select') {
        if (this._shouldTriggerChange(this.selectr.getValue())) {
          this.lastState = this.selectr.getValue();
          this.onChange(this.lastState);
        }
      }

      this.lastAction = 'close';
    });

    this.selectr.on('selectr.open', () => {
      this.lastAction = 'open';
    });
  }

  _shouldTriggerChange(currentState) {
    return (
      this.ready &&
      (this.lastState.length !== currentState.length || !this.lastState.every(item => currentState.includes(item)))
    );
  }

  _triggerChangeDebounced(currentState, time = 3000) {
    debounce(() => {
      this.lastState = currentState;
      this.onChange(this.lastState);
    }, time)();
  }

  update(selectedOptions) {
    this.ready = false;
    this.selectr.reset();
    this.selectr.setValue(selectedOptions.map(v => v.toString()));
    this.lastState = this.selectr.getValue();
    this.ready = true;
  }
}
